




































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { ISettings } from '../../model/ISettings';

@Component({
  validations: {}
})
export default class AppSettings extends Vue {
  @State(state => state.settings)
  public settings!: ISettings;
  @Action('settings/getSettings')
  private getSettings!: (force?: boolean) => Promise<ISettings>;
  @Action('settings/patchSettings')
  private patchSettings!: () => Promise<void>;
  public saved = false;

  created() {
    this.getSettings(true);
  }

  save(e: Event) {
    this.saved = false;
    this.patchSettings().then(() => {
      this.saved = true;
    });
    e.stopPropagation();
    e.preventDefault();
    return false;
  }
}
